import assetPathMap from "../data/asset-path-map.json";

const safeFileName = (url = "") => {
  try {
    const parsed = new URL(url);
    return decodeURIComponent(parsed.pathname.split("/").pop() || "").replace(
      /\+/g,
      " ",
    );
  } catch {
    return url;
  }
};

export const localAssetPath = (sourceUrl = "") => {
  if (!sourceUrl) {
    return "";
  }

  if (sourceUrl.startsWith("/assets/")) {
    return sourceUrl;
  }

  const absoluteUrl = sourceUrl.startsWith("//")
    ? `https:${sourceUrl}`
    : sourceUrl;
  const directMatch = assetPathMap[absoluteUrl];
  if (directMatch) return directMatch;

  try {
    const parsed = new URL(absoluteUrl);
    const withoutQuery = `${parsed.origin}${parsed.pathname}`;
    if (assetPathMap[withoutQuery]) return assetPathMap[withoutQuery];
  } catch {
    // The filename fallback below also supports authored relative asset values.
  }

  return `/assets/original/images/${safeFileName(sourceUrl)}`;
};
